import types from './types';
import cloneDeep from 'lodash/cloneDeep';

export const initialState = {
  loading: false,
  currentPage: 'zip-code',
  zipCode: '',
  email: '',
  availableDays: [],
  selectedDay: '',
  allergies: [],
  selectedAllergies: [],
  zipResponse: {},
  snacks: [],
  meals: [],
  selectedSnacks: {},
  // selectedMeals is now nested by planId: { planId: { mealId: qty } }
  selectedMeals: {},
  price: 0,
  minOrderMeals: 1,
  paymentMethods: [],
  giftCards: [],
  subscriptionsResult: {},
};

const orderMealALaCarte = (state = cloneDeep(initialState), action) => {
  switch (action.type) {
    case types.ORDER_MEAL_ALC__SET_FIELD:
      return {
        ...state,
        ...action.payload,
      };
    case types.ORDER_MEAL_ALC__RESET_STATE:
      return cloneDeep(initialState);
    default: {
      return state;
    }
  }
};

export default orderMealALaCarte;
